import {
  CHANGE_SIM,
  CHANGE_SIM_ERROR,
  CHANGE_SIM_CLEAN,
  CHANGE_SIM_CLEAN_ERROR,
} from '_models/redux/types';

const initialState = {
  response: [],
  error: undefined,
  loading: false,
};

export default function changeSimReducer(state = initialState, action) {
  switch (action.type) {
    case CHANGE_SIM:
    case CHANGE_SIM_CLEAN:
      return {
        ...state,
        response: action.payload,
        loading: true,
      };

    case CHANGE_SIM_ERROR:
    case CHANGE_SIM_CLEAN_ERROR:
      return {
        ...state,
        error: action.payload,
        loading: false,
      };
    default:
      return state;
  }
}
